"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaCommentaire = exports.panelFerme = exports.panelCommentaire = exports.iconeCorrigerNon = exports.iconeCorriger = exports.iconeSupprimer = exports.iconeCorrection = exports.iconeMasquer = exports.iconeAnnuler = exports.iconeAfficher = exports.iconeAjouter = exports.codeSupprimer = exports.codeCorriger = exports.codeMasquer = exports.codeAfficher = exports.codeAjouter = exports.codeInitial = exports.titreCorriger = exports.titreValeurInitiale = exports.titreSupprimer = exports.titreMasquer = exports.titreAfficher = exports.titreAnnuler = exports.titreAjouter = exports.titreCommenter = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _core = require("@material-ui/core");

var _MfaAireTexte = require("./MfaAireTexte");

var _MfaDialogue = require("./MfaDialogue");

var _MfaEnveloppe = require("./MfaEnveloppe");

var _utilitaires = require("../utils/utilitaires");

require("../css/mfa-commentaire.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var titreCommenter = "Commentaire";
exports.titreCommenter = titreCommenter;
var titreAjouter = "Ajouter un commentaire";
exports.titreAjouter = titreAjouter;
var titreAnnuler = "Annuler";
exports.titreAnnuler = titreAnnuler;
var titreAfficher = "Afficher";
exports.titreAfficher = titreAfficher;
var titreMasquer = "Masquer";
exports.titreMasquer = titreMasquer;
var titreSupprimer = "Supprimer";
exports.titreSupprimer = titreSupprimer;
var titreValeurInitiale = "Init.";
exports.titreValeurInitiale = titreValeurInitiale;
var titreCorriger = "Corrigé";
exports.titreCorriger = titreCorriger;
var codeInitial = 0;
exports.codeInitial = codeInitial;
var codeAjouter = 1;
exports.codeAjouter = codeAjouter;
var codeAfficher = 2;
exports.codeAfficher = codeAfficher;
var codeMasquer = 3;
exports.codeMasquer = codeMasquer;
var codeCorriger = 4;
exports.codeCorriger = codeCorriger;
var codeSupprimer = 5;
exports.codeSupprimer = codeSupprimer;
var iconeAjouter = "plus circle";
exports.iconeAjouter = iconeAjouter;
var iconeAfficher = "eye";
exports.iconeAfficher = iconeAfficher;
var iconeAnnuler = "undo";
exports.iconeAnnuler = iconeAnnuler;
var iconeMasquer = "eye slash";
exports.iconeMasquer = iconeMasquer;
var iconeCorrection = "warning sign";
exports.iconeCorrection = iconeCorrection;
var iconeSupprimer = "delete";
exports.iconeSupprimer = iconeSupprimer;
var iconeCorriger = "check square";
exports.iconeCorriger = iconeCorriger;
var iconeCorrigerNon = "square outline";
exports.iconeCorrigerNon = iconeCorrigerNon;
var panelCommentaire = "panelCommentaire";
exports.panelCommentaire = panelCommentaire;
var panelFerme = "";
exports.panelFerme = panelFerme;

var MfaCommentaire = /*#__PURE__*/function (_Component) {
  _inherits(MfaCommentaire, _Component);

  var _super = _createSuper(MfaCommentaire);

  function MfaCommentaire(props) {
    var _this;

    _classCallCheck(this, MfaCommentaire);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "surSuppression", function (event) {
      if (_this.state.desactive) {
        event.stopPropagation();
        return;
      }

      if (_this.state.confirmerSuppression === true) {
        _this.setState({
          dialogueSuppressionVisible: !_this.state.dialogueSuppressionVisible
        });

        return;
      }

      if (_this.state.etatActuel === codeAfficher) {
        event.stopPropagation();
      }

      _this.setState({
        etatActuel: codeInitial,
        valeur: '',
        commentaire: ''
      }, function () {
        _this.remettreBoutonAnnulerInVisible();

        _this.changementEtat(function () {
          var surSupression = _this.props.surSupression;

          if ((0, _utilitaires.estDefini)(surSupression)) {
            surSupression();
          }

          if ((0, _utilitaires.estDefini)(_this.props.surAviserSuppression)) {
            _this.props.surAviserSuppression();
          }
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "surRetablissement", function () {
      var surRetablissement = _this.props.surRetablissement;

      _this.setState({
        etatActuel: codeMasquer,
        lectureSeule: false,
        dialogueSuppressionVisible: false,
        correction: false
      }, function () {
        _this.remettreBoutonAnnulerInVisible();

        _this.changementEtat(function () {
          if (!(0, _utilitaires.estDefini)(surRetablissement)) {
            return;
          }

          surRetablissement();
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "surCorrection", function (event) {
      if (_this.state.desactive) {
        event.stopPropagation();
        return;
      }

      var nouvelEtatCorrige = !_this.state.estCorrige;

      _this.setState({
        estCorrige: nouvelEtatCorrige
      }, function () {
        _this.changementEtatCorrection();
      });

      if ((0, _utilitaires.estDefini)(_this.props.surCorrection)) {
        _this.props.surCorrection(nouvelEtatCorrige);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "surAnnulation", function (event) {
      if (_this.state.desactive) {
        event.stopPropagation();
        return;
      }

      if (_this.state.confirmerAnnulation === true) {
        _this.setState({
          dialogueAnnulationVisible: !_this.state.dialogueAnnulationVisible
        }, function () {});
      } else {
        _this.remettreBoutonAnnulerInVisible();

        if ((0, _utilitaires.estDefini)(_this.props.surAviserAnnulation)) {
          _this.props.surAviserAnnulation();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "surChangementAction", function (event) {
      var etatActuel = _this.state.etatActuel;

      if (_this.props.masquable === false) {
        if (etatActuel !== codeAfficher) {
          if (_this.state.etatActuel !== codeInitial) {
            event.stopPropagation();
            return;
          }
        }
      }

      var codeMemeDesactive = [codeMasquer, codeAfficher];

      if (_this.state.desactive && codeMemeDesactive.indexOf(etatActuel) == -1) {
        event.stopPropagation();
        return;
      }

      var prochainEtat = _this.obtenirProchainEtat();

      if (_this.state.etatActuel === codeInitial && prochainEtat == codeMasquer) {
        if ((0, _utilitaires.estDefini)(_this.props.surAviserAjout)) {
          _this.props.surAviserAjout();
        }
      }

      var surChangementAction = _this.props.surChangementAction;

      if ((0, _utilitaires.estDefini)(surChangementAction)) {
        surChangementAction(prochainEtat);
      }

      var _assertThisInitialize = _assertThisInitialized(_this),
          conteneur = _assertThisInitialize.conteneur;

      if ((0, _utilitaires.estDefini)(conteneur) && conteneur.style.height === 'auto') {
        conteneur.style.height = "".concat(_this.obtenirValeurHauteurConteneur(), "px");
      }

      _this.setState({
        etatActuel: prochainEtat
      }, function () {
        _this.changementEtat(function () {
          window.requestAnimationFrame(function () {
            var _assertThisInitialize2 = _assertThisInitialized(_this),
                conteneur = _assertThisInitialize2.conteneur;

            if ((0, _utilitaires.estDefini)(conteneur)) {
              _this.lancerObserveurPourModificationHauteur();

              conteneur.style.height = "".concat(_this.obtenirValeurHauteurConteneur(), "px");
            }
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "surConfirmerAnnulationNegative", function () {
      _this.setState({
        dialogueAnnulationVisible: !_this.state.dialogueAnnulationVisible
      }, function () {
        _this.remettreBoutonAnnulerInVisible();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "surConfirmerAnnulationPositive", function () {
      _this.setState({
        dialogueAnnulationVisible: !_this.state.dialogueAnnulationVisible
      }, function () {
        _this.remettreBoutonAnnulerInVisible();

        if ((0, _utilitaires.estDefini)(_this.props.surAviserAnnulation)) {
          _this.props.surAviserAnnulation();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "surConfirmerSuppressionNegative", function () {
      _this.setState({
        dialogueSuppressionVisible: !_this.state.dialogueSuppressionVisible
      });
    });

    _defineProperty(_assertThisInitialized(_this), "surConfirmerSuppressionPositive", function () {
      _this.setState({
        etatActuel: codeInitial,
        dialogueSuppressionVisible: !_this.state.dialogueSuppressionVisible,
        valeur: '',
        commentaire: ''
      }, function () {
        _this.remettreBoutonAnnulerInVisible();

        _this.changementEtat();

        if ((0, _utilitaires.estDefini)(_this.props.surAviserSuppression)) {
          _this.props.surAviserSuppression();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "conteneur", void 0);

    _defineProperty(_assertThisInitialized(_this), "element", void 0);

    _this.state = {
      etatActuel: (0, _utilitaires.estDefini)(props.codeInitial) ? props.codeInitial : codeInitial,
      titre: '',
      valeur: _this.props.valeur,
      valeurInitiale: _this.props.valeur,
      commentaire: _this.props.valeur,
      correction: props.correction === true,
      etendre: props.etendre === true,
      afficherBoutonAnnuler: props.affichageBoutonAnnuler === true,
      confirmerAnnulation: props.confirmationAnnulation === true,
      confirmerSuppression: props.confirmerSuppression === true,
      nomIcone: '',
      activeIndex: 0,
      estCorrige: _this.props.estCorrige,
      estSupprime: false,
      retourValeurInitiale: false,
      panelEtendu: '',
      boutonAnnulerVisible: false,
      dialogueAnnulationVisible: false,
      dialogueSuppressionVisible: false,
      lectureSeule: props.lectureSeule === true,
      desactive: props.desactive === true
    };
    _this.surChangementCommentaire = _this.surChangementCommentaire.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MfaCommentaire, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var codeAction = this.state.etatActuel;
      var sansCodeInitale = !(0, _utilitaires.estDefini)(this.props.codeInitial);
      var etendre = sansCodeInitale ? false : this.state.etendre;

      if (sansCodeInitale && (0, _utilitaires.nestPasNulOuVide)(this.state.commentaire)) {
        codeAction = codeAfficher;
      }

      if (sansCodeInitale) {
        if ((0, _utilitaires.elementEstEgalA)(this.props.correction, true)) {
          etendre = true;
          codeAction = codeMasquer;
        } else if ((0, _utilitaires.elementEstEgalA)(this.props.etendre, true)) {
          codeAction = codeMasquer;
        }
      }

      this.setState({
        etatActuel: codeAction,
        etendre: etendre
      }, function () {
        _this2.changementEtat(function () {
          var conteneur = _this2.conteneur;

          if ((0, _utilitaires.estDefini)(conteneur)) {
            conteneur.style.height = _this2.state.panelEtendu !== panelCommentaire ? '0px' : 'auto';
          }
        });
      });
    }
  }, {
    key: "obtenirHauteurConteneur",
    value: function obtenirHauteurConteneur() {
      var conteneur = this.conteneur;

      if (!(0, _utilitaires.estDefini)(conteneur) || conteneur.children.length === 0) {
        return 0;
      }

      return conteneur.children[0].getBoundingClientRect().height;
    }
  }, {
    key: "obtenirProchainEtat",
    value: function obtenirProchainEtat() {
      var nouvelEtat = this.state.etatActuel;

      switch (this.state.etatActuel) {
        case codeInitial:
          nouvelEtat = codeMasquer;
          break;

        case codeAjouter:
          nouvelEtat = codeMasquer;
          break;

        case codeAfficher:
          nouvelEtat = codeMasquer;
          break;

        case codeMasquer:
          nouvelEtat = codeAfficher;
          break;

        case codeCorriger:
          nouveauTitre = titreCommenter;
          break;
      }

      return nouvelEtat;
    }
  }, {
    key: "changementEtat",
    value: function changementEtat(callback) {
      var nouvelIcone = iconeAjouter;
      var nouveauTitre = titreMasquer;
      var etatEstSupprime = this.state.estSupprime;
      var etatEstCorrige = this.state.estCorrige;
      var correction = this.state.correction;
      var nouvelEtatPanel = this.state.panelEtendu === panelCommentaire ? panelFerme : panelCommentaire;

      switch (this.state.etatActuel) {
        case codeInitial:
          nouveauTitre = titreAjouter;
          nouvelIcone = iconeAjouter;
          etatEstSupprime = false;
          etatEstCorrige = false;
          correction = false;
          nouvelEtatPanel = panelFerme;
          break;

        case codeMasquer:
          nouveauTitre = titreMasquer;
          nouvelIcone = iconeMasquer;
          etatEstSupprime = false;
          etatEstCorrige = false;
          nouvelEtatPanel = panelCommentaire;

          if (this.state.correction === true) {
            if (this.state.estCorrige === false) {
              nouvelIcone = iconeCorrection;
              nouveauTitre = titreCommenter;
            }
          }

          if (this.props.masquable === false) {
            nouveauTitre = titreCommenter;
            nouvelIcone = iconeCorrection;
          }

          break;

        case codeAfficher:
          nouveauTitre = titreAfficher;
          nouvelIcone = iconeAfficher;
          etatEstSupprime = false;
          etatEstCorrige = false;
          nouvelEtatPanel = panelFerme;

          if (this.state.correction === true) {
            if (this.state.estCorrige === false) {
              nouvelIcone = iconeCorrection;
              nouveauTitre = titreCommenter;
            }
          }

          break;

        case codeAjouter:
          nouveauTitre = titreMasquer;
          nouvelIcone = iconeAjouter;
          etatEstSupprime = false;
          etatEstCorrige = false;
          break;

        case codeCorriger:
          nouveauTitre = titreCommenter;
          nouvelIcone = iconeCorrection;
          break;
      }

      if (this.state.estCorrige === true) {
        this.setState({
          titre: nouveauTitre,
          nomIcone: nouvelIcone,
          correction: correction,
          estSupprime: etatEstSupprime,
          panelEtendu: nouvelEtatPanel
        }, callback);
      } else {
        this.setState({
          titre: nouveauTitre,
          nomIcone: nouvelIcone,
          correction: correction,
          estSupprime: etatEstSupprime,
          estCorrige: etatEstCorrige,
          panelEtendu: nouvelEtatPanel
        }, callback);
      }
    }
  }, {
    key: "changementEtatCorrection",
    value: function changementEtatCorrection() {
      var nouvelIcone = iconeCorrection;
      var nouveauTitre = titreCommenter;
      var nouvelAffichage = this.state.estCorrige === false;

      if (nouvelAffichage === false) {
        switch (this.state.etatActuel) {
          case codeMasquer:
            nouvelIcone = iconeMasquer;

            if (this.props.masquable) {
              nouveauTitre = titreMasquer;
            } else {
              nouvelIcone = iconeCorrection;
            }

            nouvelAffichage = true;
            break;

          case codeAfficher:
            nouvelIcone = iconeAfficher;
            nouveauTitre = titreAfficher;
            nouvelAffichage = true;
            break;
        }
      }

      if (nouvelAffichage) {
        this.setState({
          titre: nouveauTitre,
          nomIcone: nouvelIcone
        });
      }
    }
  }, {
    key: "remettreBoutonAnnulerInVisible",
    value: function remettreBoutonAnnulerInVisible() {
      this.setState({
        boutonAnnulerVisible: false
      });
    }
  }, {
    key: "obtenirValeurHauteurConteneur",
    value: function obtenirValeurHauteurConteneur() {
      return this.state.panelEtendu === panelCommentaire ? this.obtenirHauteurConteneur() : 0;
    }
  }, {
    key: "lancerObserveurPourModificationHauteur",
    value: function lancerObserveurPourModificationHauteur() {
      var _this3 = this;

      (0, _utilitaires.boucleAsyncrone)(function () {}, function () {
        var conteneur = _this3.conteneur;

        var hauteur = _this3.obtenirValeurHauteurConteneur();

        var hauteurCourante = conteneur.getBoundingClientRect().height;

        if (hauteurCourante === hauteur || hauteur === 0 && hauteurCourante < 0 || hauteur > 0 && hauteurCourante > hauteur) {
          conteneur.style.height = 'auto';
          return true;
        }

        return false;
      });
    }
  }, {
    key: "surChangementCommentaire",
    value: function surChangementCommentaire(texte) {
      if (this.state.afficherBoutonAnnuler === true && this.state.boutonAnnulerVisible === false) {
        this.setState({
          boutonAnnulerVisible: true
        });
      }

      this.setState({
        commentaire: texte
      });

      if ((0, _utilitaires.estDefini)(this.props.surChangement)) {
        this.props.surChangement(texte);
      }
    }
  }, {
    key: "afficherEnAttenteCorrection",
    value: function afficherEnAttenteCorrection() {
      return this.state.correction === true && this.props.estCorrigeable === false && this.props.estCorrige !== true;
    }
  }, {
    key: "afficherRetablir",
    value: function afficherRetablir() {
      return this.afficherSuppression() && this.props.afficherRetablirCommentaires === true && this.state.correction === true && this.props.estCorrigeable === false && this.props.estCorrige === true; //return true;
    }
  }, {
    key: "afficherSuppression",
    value: function afficherSuppression() {
      if (this.state.etatActuel === codeInitial || this.state.etatActuel === codeAjouter || //(this.state.correction === true) ||
      (0, _utilitaires.estDefini)(this.props.estCorrige) && !this.props.estCorrige && this.state.correction || this.props.afficherSupprimerCommentaires !== true || this.state.lectureSeule === true) {
        return false;
      }

      return true;
    }
  }, {
    key: "afficherAnnulation",
    value: function afficherAnnulation() {
      if (this.state.afficherBoutonAnnuler === true && this.state.boutonAnnulerVisible === true && this.state.correction === false && this.state.lectureSeule === false) {
        return true;
      }

      return false;
    }
  }, {
    key: "afficherCorrection",
    value: function afficherCorrection() {
      if (this.state.etatActuel === codeInitial || this.state.etatActuel === codeAjouter || this.props.estCorrigeable === false || this.state.correction === false || this.state.lectureSeule === true) {
        return false;
      }

      return true;
    }
  }, {
    key: "estLectureSeule",
    value: function estLectureSeule() {
      if (this.state.correction === true) {
        return false;
      }

      return this.state.lectureSeule;
    }
  }, {
    key: "estDesactive",
    value: function estDesactive() {
      if (this.state.correction === false && this.state.lectureSeule === true) {
        return true;
      }

      return this.afficherCorrection() || this.afficherEnAttenteCorrection() || this.afficherRetablir();
    }
  }, {
    key: "ImageIconeCorrige",
    value: function ImageIconeCorrige() {
      if (this.state.estCorrige) {
        return iconeCorriger;
      }

      return iconeCorrigerNon;
    }
  }, {
    key: "cacherSiVide",
    value: function cacherSiVide() {
      var _this$props = this.props,
          cacherSiVide = _this$props.cacherSiVide,
          valeur = _this$props.valeur;
      return !(0, _utilitaires.nestPasNulOuVide)(valeur) && cacherSiVide === true;
    }
  }, {
    key: "renderSuppresion",
    value: function renderSuppresion() {
      return this.renderEtat('afficherSuppression', titreSupprimer, iconeSupprimer, 'surSuppression');
    }
  }, {
    key: "renderCorrection",
    value: function renderCorrection() {
      var texteCorrection = this.props.texteCorrection;
      return this.renderEtat('afficherCorrection', (0, _utilitaires.estDefini)(texteCorrection) ? texteCorrection : titreCorriger, this.ImageIconeCorrige(), 'surCorrection');
    }
  }, {
    key: "renderAnnulation",
    value: function renderAnnulation() {
      return this.renderEtat('afficherAnnulation', titreAnnuler, iconeAnnuler, 'surAnnulation');
    }
  }, {
    key: "renderEnAttenteCorrection",
    value: function renderEnAttenteCorrection() {
      return this.renderEtat('afficherEnAttenteCorrection', 'En attente de correction', iconeCorrigerNon);
    }
  }, {
    key: "renderRetablir",
    value: function renderRetablir() {
      return this.renderEtat('afficherRetablir', 'Rétablir', iconeAnnuler, 'surRetablissement');
    }
  }, {
    key: "renderEtat",
    value: function renderEtat(fonctionRender, titre, nomIcone, fonctionClick) {
      var _this4 = this;

      var texteCorrection = this.props.texteCorrection;
      var style = (0, _utilitaires.estDefini)(texteCorrection) ? {
        width: "200px"
      } : null;

      if (!this[fonctionRender]()) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        key: titre,
        className: this.obtenirClasseColonne()
      }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
        onClick: function onClick(event) {
          return (0, _utilitaires.estDefini)(fonctionClick) ? _this4[fonctionClick](event) : null;
        },
        onFocus: function onFocus(event) {
          return event.stopPropagation();
        },
        control: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          name: nomIcone,
          className: this.obtenirClasseIcone(true),
          link: true
        }), /*#__PURE__*/_react.default.createElement("label", {
          className: this.obtenirClasseTitre(),
          style: style
        }, titre)),
        label: ''
      }));
    }
  }, {
    key: "surCliqueEnveloppe",
    value: function surCliqueEnveloppe(_ref) {
      var currentTarget = _ref.currentTarget;
      var surCliqueEnveloppe = this.props.surCliqueEnveloppe;

      if (!(0, _utilitaires.estDefini)(surCliqueEnveloppe)) {
        return;
      }

      surCliqueEnveloppe(currentTarget);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if ((0, _utilitaires.elementEstVisible)(this.props.estVisible) === false || this.cacherSiVide()) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
      }

      var properties = this.obtenirPropsFiltrees();
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(_ref3) {
          return (0, _utilitaires.enregistrerSiDefini)(_this5, 'element', _ref3);
        },
        onClick: this.surCliqueEnveloppe.bind(this)
      }, /*#__PURE__*/_react.default.createElement(_MfaEnveloppe.MfaEnveloppe, {
        taille: this.props.taille
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.obtenirNomClasse()
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.obtenirSommaireClasse()
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.obtenirClasseColonne(false)
      }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
        onClick: function onClick(event) {
          return _this5.surChangementAction(event);
        },
        onFocus: function onFocus(event) {
          return event.stopPropagation();
        },
        control: /*#__PURE__*/_react.default.createElement(_react.Fragment, null, (0, _utilitaires.nestPasNulOuVide)(this.state.nomIcone) && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          name: this.state.nomIcone,
          className: this.obtenirClasseIcone(),
          link: true
        }), /*#__PURE__*/_react.default.createElement("label", {
          className: this.obtenirClasseTitre(),
          style: {
            width: "200px"
          }
        }, this.state.titre)),
        label: ''
      })), [this.renderAnnulation(), this.renderSuppresion(), this.renderCorrection(), this.renderEnAttenteCorrection(), this.renderRetablir()]), /*#__PURE__*/_react.default.createElement("div", {
        className: "conteneur",
        ref: function ref(_ref2) {
          return (0, _utilitaires.enregistrerSiDefini)(_this5, 'conteneur', _ref2);
        }
      }, this.state.panelEtendu === panelCommentaire ? /*#__PURE__*/_react.default.createElement(_MfaAireTexte.MfaAireTexte, {
        className: this.obtenirClasseTextArea(),
        id: this.props.id,
        key: this.props.id,
        classeEnveloppe: this.obtenirClasseEnveloppe(),
        estObligatoire: true,
        valeurInitiale: this.state.commentaire,
        etiquette: this.props.etiquette,
        nombreLignes: this.props.nombreLignes,
        surChangement: this.surChangementCommentaire,
        surPerteDeFocus: this.props.surPerteDeFocus,
        lectureSeule: this.estLectureSeule(),
        desactive: this.estDesactive()
      }) : null))), /*#__PURE__*/_react.default.createElement(_MfaDialogue.MfaDialogue, {
        estVisible: this.state.dialogueAnnulationVisible,
        titre: this.props.titreConfirmerAnnulation,
        message: this.props.messageConfirmerAnnulation,
        messageboutonAnnulation: this.props.messageboutonAnnlation,
        messageboutonSortie: this.props.messageboutonConfirmation,
        surAnnulation: this.surConfirmerAnnulationNegative,
        surSortie: this.surConfirmerAnnulationPositive,
        nomIcone: this.props.nomIconeConfirmerAnnulation
      }), /*#__PURE__*/_react.default.createElement(_MfaDialogue.MfaDialogue, {
        estVisible: this.state.dialogueSuppressionVisible,
        titre: this.props.titreConfirmerSuppression,
        message: this.props.messageConfirmerSuppression,
        messageboutonAnnulation: this.props.messageboutonAnnlation,
        messageboutonSortie: this.props.messageboutonConfirmation,
        surAnnulation: this.surConfirmerSuppressionNegative,
        surSortie: this.surConfirmerSuppressionPositive,
        nomIcone: this.props.nomIconeConfirmerSuppression
      }));
    }
  }, {
    key: "obtenirNomClasse",
    value: function obtenirNomClasse() {
      return 'mfa-commentaire ';
    }
  }, {
    key: "obtenirSommaireClasse",
    value: function obtenirSommaireClasse() {
      return "accordion-sommaire";
    }
  }, {
    key: "obtenirClasseTitre",
    value: function obtenirClasseTitre(titreSeulement) {
      var nomClasse = 'titre';

      if ((0, _utilitaires.estDefini)(titreSeulement) && titreSeulement) {
        return nomClasse;
      }

      if (this.state.correction) {
        if (this.state.estCorrige) {
          nomClasse += " titre-correction-vert";
        }

        nomClasse += " titre-correction";
      }

      return nomClasse;
    }
  }, {
    key: "obtenirClasseIcone",
    value: function obtenirClasseIcone(iconeSeulement) {
      var nomClasse = 'icone';

      if ((0, _utilitaires.estDefini)(iconeSeulement) && iconeSeulement) {
        return nomClasse;
      }

      if (this.state.correction) {
        nomClasse += " icone-correction";

        if (this.state.estCorrige) {
          nomClasse += " vert";
        }
      }

      return nomClasse;
    }
  }, {
    key: "obtenirClasseEnveloppe",
    value: function obtenirClasseEnveloppe() {
      if (this.state.correction) {
        if (this.state.estCorrige) {
          return "enveloppe-correction-vert";
        }

        return "enveloppe-correction";
      }

      return null;
    }
  }, {
    key: "obtenirClasseTextArea",
    value: function obtenirClasseTextArea() {
      var nomClasse = 'texte-area';

      if (this.state.correction) {
        if (this.state.estCorrige) {
          nomClasse += " texte-area-correction-vert";
        }

        nomClasse += " texte-area-correction";
      }

      if (this.state.desactive) {
        nomClasse += " desactive";
      }

      return nomClasse;
    }
  }, {
    key: "obtenirClasseColonne",
    value: function obtenirClasseColonne() {
      var droite = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      //return `colonne ${droite ? 'droite' : ''}`;
      return "colonne";
    }
  }, {
    key: "obtenirPropsFiltrees",
    value: function obtenirPropsFiltrees() {
      return (0, _utilitaires.filtrerProprietesObjet)(this.props, ['estObligatoire', 'estVisible', 'etiquette']);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.lectureSeule !== state.lectureSeule) {
        return {
          lectureSeule: props.lectureSeule
        };
      }

      if (props.desactive !== state.desactive) {
        return {
          desactive: props.desactive
        };
      }

      return null;
    }
  }]);

  return MfaCommentaire;
}(_react.Component);

exports.MfaCommentaire = MfaCommentaire;

_defineProperty(MfaCommentaire, "defaultProps", {
  titreConfirmerAnnulation: "Annulation du commentaire",
  messageConfirmerAnnulation: "Vous voulez annuler la modification au commentaire ?",
  titreConfirmerSuppression: "Suppression du commentaire",
  messageConfirmerSuppression: "Etes-vous sûr de vouloir supprimer le commentaire ?",
  messageboutonConfirmation: "Oui",
  messageboutonAnnlation: "Non",
  nomIconeConfirmerAnnulation: "undo",
  nomIconeConfirmerSuppression: "",
  estVisible: true,
  masquable: true,
  lectureSeule: false,
  desactive: false,
  taille: "xl",
  nombreLignes: 4
});